import { render, staticRenderFns } from "./front-printing.vue?vue&type=template&id=22fc73b2"
import script from "./front-printing.vue?vue&type=script&lang=ts"
export * from "./front-printing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports